<template>
  <section class="section container pt-0">
    <validator-nav />
  </section>
</template>

<script>
import ValidatorNav from "./validator_nav/Index.vue";

export default {
  name: "TailoringOrderValidator",
  components: {
    ValidatorNav,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
